import {AttributeTypeEnum} from "./components/bo-core/enums/AttributeTypeEnum";
import {AttributeValue} from "./components/bo-core/models/AttributeValue";
import {LOCALE_DETAILS} from "./config/LocaleDetails";

const axios = require('axios');
const store = require('./config/store');
const jquery = require('jquery');
const moment = require("moment");
const moment_timezone = require("moment-timezone/builds/moment-timezone-with-data-1970-2030");

export enum NUMBER_FORMAT_SEPARATOR_TYPE {
    DECIMAL = 'decimal',
    GROUP = 'group'
}

export interface DropdownOption {
    label: string;
    value: number;
}

export  interface DropdownCandidate {
    data: DropdownOption;
    label: string;
    value: number;
}

export default class Utils {
    static readonly BACKEND_TIME_FORMAT = "HH:mm:ss";
    static readonly BACKEND_DATE_TIME_FORMAT = "YYYY-MM-DD HH:mm:ss";

    // @ts-ignore
    static API_BASE_URL: string = API_BASE_URL;
    static readonly $ = jquery;
    static readonly axios = axios;
    static readonly store = store;
    static readonly moment = moment;
    static readonly moment_timezone = moment_timezone;
    static readonly timezone = Utils.getCookie("Time-Zone") || Utils.setCookie("Time-Zone", Utils.moment_timezone.tz.guess(), 1000);
    static readonly EMAIL_REGEX = new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/g);
    static readonly ALL_EMAIL_DOMAIN_REGEX = new RegExp(/^[*]@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/g);
    static readonly API_BASE_URL_V1_POSTFIX = "/v1";
    static readonly API_BASE_URL_V2_POSTFIX = "/v2";
    static readonly SysRuleEngineRules = "sys rule engine rules";
    static readonly SysRuleEngineActions = "sys rule engine actions";
    static readonly SysRuleEngineActionsKey = 'SysRuleEngineActions';
    static readonly LOCAL_STORAGE_ITEM_LOCALE = "Locale";
    static readonly LOCAL_STORAGE_ITEM_BUILD_FE_TS = "Build FE Ts";
       
    static filterOptions = (candidate:DropdownCandidate, input:string):boolean => {
        if (input) {
           return candidate.data.label.toLowerCase().startsWith(input.toLowerCase())
        }
       return true;
    };
    
    private static readonly PUBLIC_PATHNAMES = [
        `${process.env.ENV_PREFIX}/user/activate`,
        `${process.env.ENV_PREFIX}/register`,
        `${process.env.ENV_PREFIX}/forgot-password`,
        `${process.env.ENV_PREFIX}/login`
    ];

    static readonly CONVERTIBLE_ATTRIBUTE_TYPES = new Map<AttributeTypeEnum, AttributeTypeEnum[]> ([
        [AttributeTypeEnum.TEXT, [ AttributeTypeEnum.VALUE_LIST ]]
    ]);

    static isPathPublic(pathname: string) {
        for (let publicPath of Utils.PUBLIC_PATHNAMES) {
            if (publicPath === pathname) {
                return true;
            }
        }
        return false;
    }
    static truncateString = (string = '', maxLength = 50) => {
     return   string.length > maxLength
            ? `${string.substring(0, maxLength)}…`
            : string
    }

    static getLocaleNameByTag = (localeTag: string) => {
        const label = LOCALE_DETAILS[localeTag];
        return label ? label : localeTag;
    };

    static numberFormatByLocale = (value, localeTag: string) => {
        return new Intl.NumberFormat(
            localeTag,
            { maximumFractionDigits: 20 }
        ).format(value);
    };

    /**
     * Parse a localized number to a float.
     * @param {string} stringNumber - the localized number
     * @param {string} localeTag - the locale that the number is represented in
     */
    static reverseFormattedNumber = (stringNumber, localeTag): number => {
        const thousandSeparator = Utils.getFormattedNumberSeparator(localeTag, NUMBER_FORMAT_SEPARATOR_TYPE.GROUP);
        const decimalSeparator = Utils.getFormattedNumberSeparator(localeTag, NUMBER_FORMAT_SEPARATOR_TYPE.DECIMAL);
        return parseFloat(stringNumber
            .replace(new RegExp('\\' + thousandSeparator, 'g'), '')
            .replace(new RegExp('\\' + decimalSeparator), '.')
        );
    }

    static getFormattedNumberSeparator = (localeTag: string, separatorType: NUMBER_FORMAT_SEPARATOR_TYPE) => {
        const numberWithGroupAndDecimalSeparator = 1000.1;
        return Intl.NumberFormat(localeTag)
            .formatToParts(numberWithGroupAndDecimalSeparator)
            .find(part => part.type === separatorType)
            .value;
    }

    static getReactSelectNewDesign(initialPosition?: boolean) {
        return {
            menu: (provided, state) => ({
                ...provided,
                color: state.selectProps.menuColor,
                backgroundColor: '#2D3436 !important',
                position: initialPosition ? 'initial' : 'absolute',
                zIndex: 10000
            }),
            option: (styles, { data, isDisabled, isFocused, isSelected }) => {
                if (isDisabled) {
                    return {
                        ...styles,
                        color: '#f5f4f463',
                    };
                } else {
                    return {
                        ...styles,
                        color: '#f5f4f4',
                    };
                }
            },
            input: styles => ({ ...styles, color: '#b5b5b5'}),
            placeholder: styles => ({ ...styles, color: '#b5b5b5'}),
            singleValue: styles => ({ ...styles, color: '#b5b5b5'}),
            control: base => ({
                ...base,
                minHeight: 34,
                backgroundColor: '#2D3436 !important',
            }),
            indicatorsContainer: base => ({
                ...base,
                height: 34,
                minHeight: 34
            }),
            multiValue: (styles, state) => {
                if (state.data.isFixed) {
                    return {
                        ...styles,
                        backgroundColor: '#676A6C'
                    }
                } else {
                    return {
                        ...styles,
                        backgroundColor: '#3D6367',
                    };
                }
            },
            multiValueLabel: (styles, state ) => ({
                ...styles,
                color: '#F5F5F5',
            }),
            multiValueRemove: (styles, state) => {
                if (state.data.isFixed) {
                    return {
                        ...styles,
                        display: 'none'
                    }
                } else {
                    return {
                        ...styles,
                        color: '#F5F5F5',
                        ':hover': {
                            backgroundColor: '#3D6367',
                            color: 'black',
                            cursor: 'pointer'
                        },
                    }
                }
            },
        }
    }

    static setCookie(cname, cvalue, exdays): string {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        const expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        return cvalue
    }

    static getCookie(cname): string {
        const name = cname + "=";
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    static eventDispatcher(action, args) {
        Utils.$(document.body).trigger({
            type: action,
            args: args
        });
    };

    static utcToLocalDate = (dateString: string): string => {
        // get instance dates missing 'Z' at the end
        if (dateString.charAt(dateString.length-1) !== 'Z') {
            dateString = dateString + 'Z';
        }
        return Utils.formatDate(Utils.moment_timezone.tz(dateString, Utils.timezone));
    };

    static formatDate = (date: any): string => {
        return date.format("L LTS");
    };

    static utcToLocalTime = (timeString: string): string => {
        const localTimeFormat = Utils.moment().localeData()._longDateFormat.LTS;
        return Utils.utcToLocal(timeString, Utils.BACKEND_TIME_FORMAT, localTimeFormat);
    };

    static utcToLocal = (date: string, inFormat: string, outFormat: string): string => {
        const utcCutOff = Utils.moment_timezone.utc(date, inFormat);
        return utcCutOff.clone().tz(Utils.timezone).format(outFormat);
    };

    static localDateToUtc = (dateString: string) => {
        const localDateFormat = `${Utils.moment().localeData()._longDateFormat.L} ${Utils.moment().localeData()._longDateFormat.LTS}`;
        return Utils.localToUtc(dateString, localDateFormat, Utils.BACKEND_DATE_TIME_FORMAT);
    };

    static localTimeToUtc = (timeString: string) => {
        const localTimeFormat = Utils.moment().localeData()._longDateFormat.LTS;
        const moment = Utils.moment_timezone.tz(timeString, localTimeFormat, Utils.timezone);
        return moment.utc().format(Utils.BACKEND_TIME_FORMAT);
    };

    static localToUtc = (date: string, inFormat: string, outFormat: string): string => {
        const moment = Utils.moment_timezone.tz(date, inFormat, Utils.timezone);
        return moment.utc().format(outFormat);
    };

    static getSwaggerUrl(): string {
        let url = Utils.API_BASE_URL;
        if (url.endsWith(Utils.API_BASE_URL_V1_POSTFIX)) {
            url = url.substring(0, url.length - Utils.API_BASE_URL_V1_POSTFIX.length);
        }
        return `${url}/swagger-ui.html`;
    }

    static getGraphQLUrl(): string {
        let url = Utils.API_BASE_URL;
        if (url.endsWith(Utils.API_BASE_URL_V1_POSTFIX)) {
            url = url.substring(0, url.length - Utils.API_BASE_URL_V1_POSTFIX.length);
        }
        return `${url}/graphiql`;
    }

    static parseEmailAttributeDefaultValue(defaultValue: any, attributeValues: any[]): string {
        let mails = [];
        let attributeValueIds = JSON.parse(defaultValue);
        if (attributeValueIds.length > 0 && attributeValues.length > 0) {
            for (let i = 0; i < attributeValueIds.length; i++) {
                let attrValue = attributeValues.find(value => value.id === attributeValueIds[i]);
                if (typeof attrValue !== "undefined" && attrValue != null) {
                    mails.push(attrValue.name);
                }
            }
        }
        return JSON.stringify(mails);
    }

    static parseEmailAttributeValue(attrValue: string): string[] {
        try {
            return JSON.parse(attrValue);
        } catch(e) {
            if (attrValue === '' || (Array.isArray(attrValue) && attrValue.length === 0)) {
                return [];
            }
            if (Array.isArray(attrValue) && attrValue.length > 0) {
                return attrValue;
            }
            return attrValue.split(',');
        }
    }

    static parseEmailAttributeDefaultValueNames(value: string, attributeValuesMap: Map<Number, AttributeValue>): string {
        if (value === "[]") {
            return value;
        }
        const attributeValues = JSON.parse(value);
        const alreadyParsedValues = isNaN(Number(attributeValues[0]));
        if (alreadyParsedValues) {
            return value;
        }
        let parsedValues = [];
        for (let i = 0; i < attributeValues.length; i++) {
            const attrValueKey = Number(attributeValues[i]);
            const optionalAttributeValue = attributeValuesMap.get(attrValueKey);
            if (optionalAttributeValue) {
                parsedValues.push(optionalAttributeValue.name);
            }
        }
        return JSON.stringify(parsedValues);
    }

    static parseResponseDataToAgGridRowData = (responseData: any) => {
        return responseData.content.map(item => {
            const base = {
                id: item.id,
                tags: item.tags,
                updated: Utils.moment(item.updated, Utils.moment.ISO_8601).isValid() ? Utils.utcToLocalDate(item.updated) : item.updated
            };
            const custom = {};
            Object.keys(item.data).map((key, index) => {
                const dataViewAttr = responseData.dataView.attributes[index];
                if (dataViewAttr) {
                    switch (dataViewAttr.attribute.type) {
                        case AttributeTypeEnum.TIME:
                            custom[key] = Utils.utcToLocalTime(item.data[key]);
                            break;
                        case AttributeTypeEnum.TIMESTAMP:
                            custom[key] = Utils.moment(item.data[key], Utils.moment.ISO_8601).isValid() ? Utils.utcToLocalDate(item.data[key]) : item.data[key];
                            break;
                        case AttributeTypeEnum.LOOKUP:
                            custom[key] = JSON.parse(item.data[key]).value;
                            break;
                        default:
                            custom[key] = item.data[key];
                    }
                }
            });
            return {
                ...base,
                ...custom
            }
        });
    };

    static deep_copy = (aObject) => {
        if (!aObject) {
            return aObject;
        }

        let v;
        let bObject = Array.isArray(aObject) ? [] : {};
        for (const k in aObject) {
            v = aObject[k];
            bObject[k] = typeof v === "object" ? Utils.deep_copy(v) : v;
        }

        return bObject;
    }

    static isAttributeTypeConvertibleTo(attributeType: AttributeTypeEnum, targetType: AttributeTypeEnum): boolean {
        const conversionOptions = Utils.CONVERTIBLE_ATTRIBUTE_TYPES.get(attributeType);
        if (typeof conversionOptions === 'undefined') {
            return false;
        }
        return conversionOptions.indexOf(targetType) !== -1;
    }

    static isValidDate = (date: string) => {
        if (!Utils.isFullRegexMatchPresent(date, /(\d{0,4})-(\d{2})-(\d{2})/g)) {
            return false;
        }

        const parts = date.split("-");
        const year  = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10);
        const day   = parseInt(parts[2], 10);

        if (year < 1000 || year > 3000 || month == 0 || month > 12) {
            return false;
        }

        const monthLength = [ 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ];

        // Adjust for leap years
        if (year % 400 == 0 || (year % 100 != 0 && year % 4 == 0)) {
            monthLength[1] = 29;
        }

        // Check the range of the day
        return day > 0 && day <= monthLength[month - 1];
    };

    static isFullRegexMatchPresent = (value: string, regex: { [Symbol.match](string: string): RegExpMatchArray | null; }): boolean => {
        const matches = value.match(regex);
        if (!matches) {
            return false;
        }
        for (let match of matches) {
            if (match == value) {
                return true;
            }
        }
        return false;
    };

    static attributeV1ModelToV2Model(attribute: any) :any {
        return  {
            ...attribute,
            boClass: {
                id: attribute.boClassId
            },
            key: attribute.attrKey,
            required: attribute.isRequired,
            type: attribute.atrbType,
            unitOfMeasure: attribute.uom,
            lookupRelTypeId: attribute.lookupRelationId
        };
    }

    // Inference Methods
    static getInferenceMismatchDefinition = (params, isInferenceTemp) => {
        if (!isInferenceTemp) {
            return undefined;
        }
        const mismatchAttributes = Utils.retrieveMismatchAttributes(params.data);
        if (!mismatchAttributes) {
            return undefined;
        }
        const columnName = params.colDef.headerName;
        return mismatchAttributes.find(attr => attr.columnName == columnName);
    };

    static retrieveMismatchAttributes = (attributeData: any): any => {
        try {
            const mismatchDefinition = JSON.parse(attributeData.mismatchValuesDefinition);
            return mismatchDefinition['mismatchAttributes'];
        } catch(e) {
            return undefined;
        }
    };

    static updateLocaleFormat = (lang: string, locale: string) => {
        Utils.moment.defineLocale(locale, {
            months: Utils.moment.localeData(lang)._months,
            monthsShort: Utils.moment.localeData(lang)._monthsShort,

            weekdays: Utils.moment.localeData(lang)._weekdays,
            weekdaysMin: Utils.moment.localeData(lang)._weekdaysMin,
            weekdaysShort: Utils.moment.localeData(lang)._weekdaysShort,

            calendar: Utils.moment.localeData(lang)._calendar,
            relativeTime: Utils.moment.localeData(lang)._relativeTime
        });
        switch (locale) {
            case "be":
                Utils.moment.updateLocale(locale, {
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD.MM.YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY, HH:mm',
                        LLLL: 'dddd, D MMMM YYYY, HH:mm'
                    }
                });
                break;
            case "bn":
                Utils.moment.updateLocale(locale, {
                    longDateFormat: {
                        LT: `A h:mm`,
                        LTS: `A h:mm:ss`,
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: `D MMMM YYYY, A h:mm`,
                        LLLL: `dddd, D MMMM YYYY, A h:mm`
                    }
                });
                break;
            case "bm":
                Utils.moment.updateLocale(locale, {
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD/MM/YYYY',
                        LL: 'MMMM D YYYY',
                        LLL: 'MMMM D YYYY HH:mm',
                        LLLL: 'dddd MMMM D YYYY HH:mm'
                    }
                });
                break;
            case "br":
                Utils.moment.updateLocale(locale, {
                    longDateFormat: {
                        LT: 'h[e]mm A',
                        LTS: 'h[e]mm:ss A',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY h[e]mm A',
                        LLLL: 'dddd, D MMMM YYYY h[e]mm A'
                    }
                });
                break;
            case "ca":
                Utils.moment.updateLocale(locale, {
                    longDateFormat: {
                        LT: 'H:mm',
                        LTS: 'H:mm:ss',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        ll: 'D MMM YYYY',
                        LLL: 'D MMMM YYYY H:mm',
                        lll: 'D MMM YYYY, H:mm',
                        LLLL: 'dddd D MMMM YYYY H:mm',
                        llll: 'ddd D MMM YYYY, H:mm'
                    }
                });
                break;
            case "cv":
                Utils.moment.updateLocale(locale, {
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD-MM-YYYY',
                        LL: 'YYYY MMMM D',
                        LLL: 'YYYY MMMM D, HH:mm',
                        LLLL: 'dddd, YYYY MMMM D, HH:mm'
                    }
                });
                break;
            case "de":
                Utils.moment.updateLocale(locale, {
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD.MM.YYYY',
                        LL: 'D MMM YYYY',
                        LLL: 'D MMMM YYYY HH:mm',
                        LLLL: 'D MMMM YYYY D dddd HH:mm',
                        l: 'DD.MM.YYYY',
                        ll: 'D MMMM YYYY D',
                        lll: 'D MMMM YYYY h:mm',
                        llll: 'D MMMM YYYY dddd h:mm'
                    }
                });
                break;
            case "eo":
                Utils.moment.updateLocale(locale, {
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'YYYY-MM-DD',
                        LL: 'D MMMM, YYYY',
                        LLL: 'D MMMM, YYYY HH:mm',
                        LLLL: 'dddd, D MMMM, YYYY HH:mm'
                    }
                });
                break;
            case "es-do":
                Utils.moment.updateLocale(locale, {
                    longDateFormat: {
                        LT: 'h:mm A',
                        LTS: 'h:mm:ss A',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY h:mm A',
                        LLLL: 'dddd, D MMMM YYYY h:mm A'
                    }
                });
                break;
            case "es-us":
                Utils.moment.updateLocale(locale, {
                    longDateFormat: {
                        LT: 'h:mm A',
                        LTS: 'h:mm:ss A',
                        L: 'MM/DD/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY h:mm A',
                        LLLL: 'dddd, D MMMM YYYY h:mm A'
                    }
                });
                break;
            case "es":
                Utils.moment.updateLocale(locale, {
                    longDateFormat: {
                        LT: 'H:mm',
                        LTS: 'H:mm:ss',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY H:mm',
                        LLLL: 'dddd, D MMMM YYYY H:mm'
                    }
                });
                break;
            case "eu":
                Utils.moment.updateLocale(locale, {
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'YYYY-MM-DD',
                        LL: 'YYYY MMMM D',
                        LLL: 'YYYY MMMM D HH:mm',
                        LLLL: 'dddd, YYYY MMMM D HH:mm',
                        l: 'YYYY-M-D',
                        ll: 'YYYY MMM D',
                        lll: 'YYYY MMM D HH:mm',
                        llll: 'ddd, YYYY MMM D HH:mm'
                    }
                });
                break;
            case "fi":
                Utils.moment.updateLocale(locale, {
                    longDateFormat: {
                        LT: 'HH.mm',
                        LTS: 'HH.mm.ss',
                        L: 'DD.MM.YYYY',
                        LL: 'Do MMMM YYYY',
                        LLL: 'Do MMMM YYYY, HH.mm',
                        LLLL: 'dddd, Do MMMM YYYY, HH.mm',
                        l: 'D.M.YYYY',
                        ll: 'Do MMM YYYY',
                        lll: 'Do MMM YYYY, HH.mm',
                        llll: 'ddd, Do MMM YYYY, HH.mm'
                    }
                });
                break;
            case "gl":
                Utils.moment.updateLocale(locale, {
                    longDateFormat: {
                        LT: 'H:mm',
                        LTS: 'H:mm:ss',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY H:mm',
                        LLLL: 'dddd, D MMMM YYYY H:mm'
                    }
                });
                break;
            case "gom-latn":
                Utils.moment.updateLocale(locale, {
                    longDateFormat: {
                        LT: 'A h:mm',
                        LTS: 'A h:mm:ss',
                        L: 'DD-MM-YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY A h:mm',
                        LLLL: 'dddd, MMMM Do, YYYY, A h:mm',
                        llll: 'ddd, D MMM YYYY, A h:mm'
                    }
                });
                break;
            case "gu":
                Utils.moment.updateLocale(locale, {
                    longDateFormat: {
                        LT: 'A h:mm',
                        LTS: 'A h:mm:ss',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY, A h:mm',
                        LLLL: 'dddd, D MMMM YYYY, A h:mm'
                    }
                });
                break;
            case "he":
                Utils.moment.updateLocale(locale, {
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY HH:mm',
                        LLLL: 'dddd, D MMMM YYYY HH:mm',
                        l: 'D/M/YYYY',
                        ll: 'D MMM YYYY',
                        lll: 'D MMM YYYY HH:mm',
                        llll: 'ddd, D MMM YYYY HH:mm'
                    }
                });
                break;
            case "hi":
                Utils.moment.updateLocale(locale, {
                    longDateFormat: {
                        LT: 'A h:mm',
                        LTS: 'A h:mm:ss',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY, A h:mm',
                        LLLL: 'dddd, D MMMM YYYY, A h:mm'
                    }
                });
                break;
            case "hy-am":
                Utils.moment.updateLocale(locale, {
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD.MM.YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY, HH:mm',
                        LLLL: 'dddd, D MMMM YYYY, HH:mm'
                    }
                });
                break;
            case "ja":
                Utils.moment.updateLocale(locale, {
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'YYYY/MM/DD',
                        LL: 'YYYY M D',
                        LLL: 'YYYY M D HH:mm',
                        LLLL: 'YYYY M D dddd HH:mm',
                        l: 'YYYY/MM/DD',
                        ll: 'YYYY M D',
                        lll: 'YYYY M D HH:mm',
                        llll: 'YYYY M D (ddd) HH:mm'
                    }
                });
                break;
            case "ko":
                Utils.moment.updateLocale(locale, {
                    longDateFormat: {
                        LT: 'A h:mm',
                        LTS: 'A h:mm:ss',
                        L: 'YYYY.MM.DD.',
                        LL: 'YYYY MMMM D',
                        LLL: 'YYYY MMMM D A h:mm',
                        LLLL: 'YYYY MMMM D dddd A h:mm',
                        l: 'YYYY.MM.DD.',
                        ll: 'YYYY MMMM D',
                        lll: 'YYYY MMMM D A h:mm',
                        llll: 'YYYY MMMM D dddd A h:mm'
                    }
                });
                break;
            case "lt":
                Utils.moment.updateLocale(locale, {
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'YYYY-MM-DD',
                        LL: 'YYYY MMMM D',
                        LLL: 'YYYY MMMM D, HH:mm',
                        LLLL: 'YYYY MMMM D, dddd, HH:mm',
                        l: 'YYYY-MM-DD',
                        ll: 'YYYY MMMM D',
                        lll: 'YYYY MMMM D, HH:mm',
                        llll: 'YYYY MMMM D, ddd, HH:mm'
                    }
                });
                break;
            case "lv":
                Utils.moment.updateLocale(locale, {
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD.MM.YYYY.',
                        LL: 'YYYY. D. MMMM',
                        LLL: 'YYYY.  D. MMMM, HH:mm',
                        LLLL: 'YYYY. D. MMMM, dddd, HH:mm'
                    }
                });
                break;
            case "ml":
                Utils.moment.updateLocale(locale, {
                    longDateFormat: {
                        LT: 'A h:mm',
                        LTS: 'A h:mm:ss',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY, A h:mm',
                        LLLL: 'dddd, D MMMM YYYY, A h:mm'
                    }
                });
                break;
            case "mn":
                Utils.moment.updateLocale(locale, {
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'YYYY-MM-DD',
                        LL: 'YYYY MMMM D',
                        LLL: 'YYYY MMMM D HH:mm',
                        LLLL: 'dddd, YYYY MMMM D HH:mm'
                    }
                });
                break;
            case "mr":
                Utils.moment.updateLocale(locale, {
                    longDateFormat: {
                        LT: 'A h:mm',
                        LTS: 'A h:mm:ss',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY, A h:mm',
                        LLLL: 'dddd, D MMMM YYYY, A h:mm'
                    }
                });
                break;
            case "ne":
                Utils.moment.updateLocale(locale, {
                    longDateFormat: {
                        LT: 'A h:mm',
                        LTS: 'A h:mm:ss',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY, A h:mm',
                        LLLL: 'dddd, D MMMM YYYY, A h:mm'
                    }
                });
                break;
            case "pa-in":
                Utils.moment.updateLocale(locale, {
                    longDateFormat: {
                        LT: 'A h:mm',
                        LTS: 'A h:mm:ss',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY, A h:mm',
                        LLLL: 'dddd, D MMMM YYYY, A h:mm'
                    }
                });
                break;
            case "pt-br":
                Utils.moment.updateLocale(locale, {
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY HH:mm',
                        LLLL: 'dddd, D MMMM YYYY HH:mm'
                    }
                });
                break;
            case "pt":
                Utils.moment.updateLocale(locale, {
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY HH:mm',
                        LLLL: 'dddd, D MMMM YYYY HH:mm'
                    }
                });
                break;
            case "ru":
                Utils.moment.updateLocale(locale, {
                    longDateFormat: {
                        LT: 'H:mm',
                        LTS: 'H:mm:ss',
                        L: 'DD.MM.YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY, H:mm',
                        LLLL: 'dddd, D MMMM YYYY, H:mm'
                    }
                });
                break;
            case "se":
                Utils.moment.updateLocale(locale, {
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD.MM.YYYY',
                        LL: 'MMMM D. YYYY',
                        LLL: 'MMMM D. YYYY HH:mm',
                        LLLL: 'dddd, MMMM D. YYYY HH:mm'
                    }
                });
                break;
            case "tzl":
                Utils.moment.updateLocale(locale, {
                    longDateFormat: {
                        LT: 'HH.mm',
                        LTS: 'HH.mm.ss',
                        L: 'DD.MM.YYYY',
                        LL: 'D. MMMM YYYY',
                        LLL: 'D. MMMM YYYY HH.mm',
                        LLLL: 'dddd, D. MMMM YYYY HH.mm'
                    }
                });
                break;
            case "ug-cn":
                Utils.moment.updateLocale(locale, {
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'YYYY-MM-DD',
                        LL: 'YYYY-M-D',
                        LLL: 'YYYY-M-D-، HH:mm',
                        LLLL: 'dddd، YYYY-M-D-، HH:mm'
                    }
                });
                break;
            case "en":
                Utils.moment.updateLocale(locale, {
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'YYYY-MM-DD',
                        LL: 'YYYY-M-D',
                        LLL: 'YYYY-M-D-، HH:mm',
                        LLLL: 'dddd، YYYY-M-D-، HH:mm'
                    }
                });
                break;
            case "uk":
                Utils.moment.updateLocale(locale, {
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD.MM.YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY, HH:mm',
                        LLLL: 'dddd, D MMMM YYYY, HH:mm'
                    }
                });
                break;
            case "vi":
                Utils.moment.updateLocale(locale, {
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'DD/MM/YYYY',
                        LL: 'D MMMM YYYY',
                        LLL: 'D MMMM YYYY HH:mm',
                        LLLL: 'dddd, D MMMM YYYY HH:mm',
                        l: 'DD/M/YYYY',
                        ll: 'D MMM YYYY',
                        lll: 'D MMM YYYY HH:mm',
                        llll: 'ddd, D MMM YYYY HH:mm'
                    }
                });
                break;
            case "zh-cn":
                Utils.moment.updateLocale(locale, {
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'YYYY/MM/DD',
                        LL: 'YYYY M D ',
                        LLL: 'YYYY M D Ah',
                        LLLL: 'YYYY M D ddddAh mm ',
                        l: 'YYYY/M/D',
                        ll: 'YYYY M D ',
                        lll: 'YYYY M D  HH:mm',
                        llll: 'YYYY M D dddd HH:mm'
                    }
                });
                break;
            case "zh-hk":
                Utils.moment.updateLocale(locale, {
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'YYYY/MM/DD',
                        LL: 'YYYY M D',
                        LLL: 'YYYY M D HH:mm',
                        LLLL: 'YYYY M D dddd HH:mm',
                        l: 'YYYY/M/D',
                        ll: 'YYYY M D',
                        lll: 'YYYY M D HH:mm',
                        llll: 'YYYY M D dddd HH:mm'
                    }
                });
                break;
            case "zh-tw":
                Utils.moment.updateLocale(locale, {
                    longDateFormat: {
                        LT: 'HH:mm',
                        LTS: 'HH:mm:ss',
                        L: 'YYYY/MM/DD',
                        LL: 'YYYY M D',
                        LLL: 'YYYY M D HH:mm',
                        LLLL: 'YYYY M D dddd HH:mm',
                        l: 'YYYY/M/D',
                        ll: 'YYYY M D',
                        lll: 'YYYY M D HH:mm',
                        llll: 'YYYY M D dddd HH:mm'
                    }
                });
                break;
            default :
                moment.updateLocale(locale, {
                    longDateFormat: Utils.moment.localeData(locale)._longDateFormat
                });
        }
    };

    /**
     * Summary:
     * Mostly used when the user opens a modal and after closing it
     * this method removes the focus on the active elements, for example
     * the button which opens the modal. This prevents the modal to opens
     * again when the user presses enter
     */
    static blurTheActiveElements = () => {
        if (document.activeElement) {
            Utils.$(document.activeElement).blur();
        }
    }
}



// WEBPACK FOOTER //
// ./app/Utils.ts